import { Injectable } from '@angular/core';
import { VueServerMessage } from '@vue/vueframework';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountMaintenanceMessagesService {
  private messages$: BehaviorSubject<VueServerMessage[]> = new BehaviorSubject([]);

  public get messages(): Observable<VueServerMessage[]> {
    return this.messages$.asObservable();
  }

  public setMessage(msg: VueServerMessage): void {
    this.messages$.next([ msg ]);
  }

  public clearMessages(): void {
    this.messages$.next([]);
  }
}
